import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changePassword } from "@core/services/change-password";
import type {
  ApiErrorResponse,
  ServiceError,
  TChangePwdSchema,
} from "@core/types";
import { usePromiseToast } from "./usePromiseToast";
import { useTranslate } from "@core/hooks";

export function useChangePwd(invalidate_sessions = false) {
  const queryClient = useQueryClient();
  const { toastify } = usePromiseToast();
  const { t } = useTranslate("auth");

  return useMutation<void, ApiErrorResponse, TChangePwdSchema>({
    mutationFn: (payload: TChangePwdSchema) => {
      const controller = new AbortController();

      const promise = changePassword(
        payload,
        controller.signal,
        invalidate_sessions,
      );

      void toastify(
        t,
        promise,
        {
          loading: "profile.change-password.toast.loading",
          success: "profile.change-password.toast.success",
          error: {
            key: (err: unknown) =>
              "errors." + ((err as ServiceError).code ?? "UNKNOWN_ERROR"),
          },
        },
        { autoCloseMs: 4000 },
      );

      return promise;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
  });
}
